import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseCompanyBranchesProps<T> = {
  filters?: {
    search?: string
    companyId?: string
    pageSize?: number
  }
  mapper?: (data: any) => T,
}

export const useCompanyBranches = <T,>({
  filters: { companyId, search = '', pageSize = 50 } = {},
  mapper = Mapper.default<T>(),
}: UseCompanyBranchesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['companyBranches', companyId, search, pageSize],
    queryFn: () => {
      return privateAxios.get('/client/company_branches', {
        params: {
          'q[company_id_eq]': companyId,
          page_size: pageSize,
          search
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
